import { render } from "./inline-skill-selector.vue?vue&type=template&id=6fc3fa50&scoped=true"
import script from "./inline-skill-selector.vue?vue&type=script&lang=js"
export * from "./inline-skill-selector.vue?vue&type=script&lang=js"

import "./inline-skill-selector.vue?vue&type=style&index=0&id=6fc3fa50&lang=sass&scoped=true"
/* custom blocks */
import block0 from "./inline-skill-selector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc3fa50"]])

export default __exports__